import React from "react";
import { CDN_URL_COOKIE } from "../../hooks/useCdnUrl";
import { CookieListItem } from "./cookie-list-item";

import "./cookie-list.css";
import { CookieTextListItem } from "./cookie-text-list-item";

export const CookieList = () => {
	return (
		<div className="cookie-list">
			<CookieListItem label="Force mobile creator" cookieKey="ForceMobileCreator" />
			<CookieTextListItem cookieKey={CDN_URL_COOKIE} label="Cdn url" />
		</div>
	);
};
CookieList.displayName = "CookieList";
